import { rootReducer } from './root-reducer';
import { rootSaga } from './sagas';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore, compose } from 'redux';

const sagaMiddleware = createSagaMiddleware();

// eslint-disable-next-line no-underscore-dangle
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = composeEnhancers(applyMiddleware(sagaMiddleware))(createStore)(rootReducer);

sagaMiddleware.run(rootSaga);

const dispatch = store.dispatch;

export { dispatch };
